import { Vector3, Mesh, Line, Points } from 'three';
// Builds a stable, session-scoped identifier for a 3D object from its
// geometry, scene path, and world position.
export function generateUUIDFromGeometryAndHierarchy(workspaceId, object3D) {
    var _a, _b;
    let geometryHash = '';
    const hasGeometry = (object3D instanceof Mesh || object3D instanceof Line || object3D instanceof Points) &&
        ((_b = (_a = object3D.geometry) === null || _a === void 0 ? void 0 : _a.attributes) === null || _b === void 0 ? void 0 : _b.position);
    if (hasGeometry) {
        const positionAttr = object3D.geometry.attributes.position;
        geometryHash = simpleHash(positionAttr.array);
    }
    const hierarchyPath = buildHierarchyPath(object3D);
    const worldPosition = new Vector3();
    object3D.getWorldPosition(worldPosition);
    const positionStr = `${worldPosition.x.toFixed(4)},${worldPosition.y.toFixed(4)},${worldPosition.z.toFixed(4)}`;
    const combined = `${workspaceId}${geometryHash}|${hierarchyPath}|${positionStr}`;
    return hashString(combined);
}
// Non-cryptographic FNV-1a hash. Stable and unique within a viewer session.
function hashString(str) {
    let h1 = 0x811c9dc5;
    let h2 = 0x811c9dc5;
    for (let i = 0; i < str.length; i++) {
        const code = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ code, 0x01000193);
        h2 = Math.imul(h2 ^ code, 0x85ebca6b);
    }
    return (h1 >>> 0).toString(16).padStart(8, '0') + (h2 >>> 0).toString(16).padStart(8, '0');
}
function buildHierarchyPath(object3D) {
    var _a;
    const names = [];
    let obj = object3D;
    while (obj) {
        names.unshift(obj.name || obj.type);
        obj = (_a = obj.parent) !== null && _a !== void 0 ? _a : undefined;
    }
    return names.join('/');
}
function simpleHash(array) {
    let hash = 0;
    for (const item of array) {
        const val = Math.fround(item); // reduce precision slightly for stability
        hash = (hash * 31 + Math.round(val * 1000)) >>> 0;
    }
    return hash.toString(16);
}
